import React from 'react';
import { MapPin, Clock, Navigation } from 'lucide-react';

export const LocationSection = () => {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-br from-slate-50 via-purple-50 to-orange-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Visit Our <span className="bg-gradient-to-r from-purple-600 to-orange-600 bg-clip-text text-transparent">Editing School</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Come experience our state-of-the-art editing facilities in the heart of Koramangala, Bangalore
          </p>
        </div>

        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 items-stretch">
          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-2xl border-4 border-white h-full min-h-[550px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.618603096953!2d77.61412729999999!3d12.9322172!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1585275e0b65%3A0xffa0e171b577b67b!2sMatchframe%20Editing%20School%20Bengaluru!5e0!3m2!1sen!2s!4v1761076934963!5m2!1sen!2s"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="MatchFrame Editing School Location"
              className="animate-fade-in"
            ></iframe>
          </div>

          {/* Location Details */}
          <div className="space-y-6 flex flex-col">
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-slate-100">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <MapPin className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 text-lg mb-2">Our Address</h3>
                  <p className="text-slate-600 leading-relaxed">
                    Unit #309, 3rd Floor, No. 77/A, Workafella,<br />
                    Jyothi Nivas College Road,<br />
                    Koramangala Industrial Layout, Koramangala,<br />
                    Bangalore, Karnataka 560095, India
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border border-slate-100">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Clock className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 text-lg mb-2">Operating Hours</h3>
                  <div className="text-slate-600 space-y-1">
                    <p><span className="font-semibold">Monday - Friday:</span> 8:00 AM - 8:00 PM</p>
                    <p><span className="font-semibold">Saturday:</span> 8:00 AM - 4:00 PM</p>
                    <p className="text-slate-500 text-sm mt-2">Sunday: Closed</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border border-slate-100">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-6 w-6 text-white">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 text-lg mb-2">Contact Number</h3>
                  <a href="tel:+919632406669" className="text-purple-600 hover:text-orange-600 font-semibold text-lg transition-colors duration-300">
                    +91 96324 06669
                  </a>
                  <p className="text-slate-500 text-sm mt-1">Call us for admissions & inquiries</p>
                </div>
              </div>
            </div>

            <a
              href="https://maps.app.goo.gl/BK7JJQdSVe71Uu55A"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 w-full bg-gradient-to-r from-purple-600 to-orange-600 text-white px-8 py-4 rounded-xl font-bold text-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
            >
              <Navigation className="h-5 w-5" />
              Get Directions
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
